import { render } from "./Registration.vue?vue&type=template&id=cb34f8ea&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=cb34f8ea&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb34f8ea"]])

export default __exports__